import styled from "styled-components";

import {
  DefaultDraggableTableWrapper,
  DefaultTableListWrapper,
} from "@FillInTableContainer/shared/styles/groupTable.style";

export const TableCreatorTableListWrapper = styled(DefaultTableListWrapper)`
  background-color: transparent;
`;

export const DraggableTableWrapper = styled(DefaultDraggableTableWrapper)``;
